/**
 * 考试管理 相关菜单配置
 *
 */
import { lazyLoad } from "@/utils/lazyLoad";
const examManageRoute = [
  {
    component: lazyLoad,
    path: "/examManage",
    meta: {
      title: "考试及问卷",
      icon: "icon-exam-manage",
    },
    children: [
      {
        path: "/exam/list",
        name: "examList",
        component: () =>
          import(
            /* webpackChunkName: "examManage" */ "@/pages/examManage/list"
          ),
        meta: {
          title: "考试/问卷列表",
          // relatedPermission: "考试/问卷列表",
        },
      },
      {
        path: "/exam/record",
        name: "examRecord",
        component: () =>
          import(
            /* webpackChunkName: "examManage" */ "@/pages/examManage/examRecord"
          ),
        meta: {
          title: "考试记录",
        },
      },
    ],
  },
];
export default examManageRoute;
